<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="p-3" v-if="questocked.length > 0">
            <h2 class="text-center">{{ questocked[0].name }}</h2>
            <h4 class="text-center" v-if="questocked.length > 0">
              This Table has {{ questocked[0].data.length }} rows
            </h4>
            <tabler
              v-if="questocked.length > 0"
              class="esq m-1 p-2"
              :datas="questocked[0].data"
              :fields="questocked[0].fields"
            ></tabler>
          </div>
          <h3 class="text-center">Select Institution to Mark Question Free or Premium</h3>
          <InstitutionsList
            v-for="(institution, index) in usedatas"
            :key="index"
            :institution="institution"
            :where="loc"
          />
          <div class="text-center vmore" v-if="endnum < endss">
            <div class="viewmore" @click="showMore">
              <b-icon-chevron-down font-scale="2" class="mt-3" animation="cylon-vertical"
                >View More</b-icon-chevron-down
              >
            </div>
            <p class="p-1 m-1 textboldsf">Show More</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import InstitutionsList from "@/components/admin/InstitutionsList.vue";
import Tabler from "@/components/admin/Tabler";
import { mapState, mapActions } from "vuex";
import store from "@/store";

export default {
  components: {
    InstitutionsList,
    Tabler,
  },

  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      loc: "mqinsti",
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchInstitutions");
    store.dispatch("admin/fetchQuestionsall");
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setinextid(to.params.trackid).then(() => {
      next();
    });
  },
  created() {
    //this.fetchQuestions(this.name)
    this.queryQStocked();
  },
  methods: {
    ...mapActions("admin", ["fetchInstitutions", "setinextid", "queryQStocked"]),
    showMore() {
      let newend = this.endnum + this.intervalnum;

      if (newend < this.endss) {
        this.endnum = newend;
      } else {
        this.endnum = this.limitnum;
      }
    },
  },
  computed: {
    ...mapState({
      name: (state) => state.loginmaster.details.fullname,
      institutionsarr: (state) => state.admin.listinstitutions,
      questocked: (state) => state.admin.questocked,
    }),
    usedatas() {
      return this.institutionsarr.slice(0, this.endnum);
    },
    endss() {
      let end = this.institutionsarr.length;
      return end;
    },
  },
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
</style>
